export class FindingExclusionResourceFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionResourceFilter.attributeTypeMap;
    }
    constructor() {
    }
}
